import { DataDisplay, formatCurrency, formatPercent, Grid, pn, useElementBreakpoints } from "@compass/core";
import { ContributorMatch, ContributorMatchViewResource } from "generated/openApi";
import "moment-timezone";

export const SideInfo = (props: { match: ContributorMatch; viewResource: ContributorMatchViewResource }) => {
  const { breakpointsRef, xSmallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorMatch>("hourlySalary"))?.displayName}
        >
          {formatCurrency(props.match.hourlySalary)}
        </DataDisplay>
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay label={properties.find((x) => x.propertyName === pn<ContributorMatch>("amount"))?.displayName}>
          {formatCurrency(props.match.amount)}
        </DataDisplay>
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorMatch>("benefitAmount"))?.displayName}
        >
          {formatCurrency(props.match.benefitAmount)}
        </DataDisplay>
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorMatch>("medicalBenefitAmount"))?.displayName}
        >
          {formatCurrency(props.match.medicalBenefitAmount)}
        </DataDisplay>
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorMatch>("totalAmount"))?.displayName}
        >
          {formatCurrency(props.match.totalAmount)}
        </DataDisplay>
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorMatch>("milesAmount"))?.displayName}
        >
          {formatCurrency(props.match.milesAmount)}
        </DataDisplay>
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorMatch>("indirectPercent"))?.displayName}
        >
          {formatPercent(props.match.indirectPercent)}
        </DataDisplay>
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorMatch>("indirectCostAmount"))?.displayName}
        >
          {formatCurrency(props.match.indirectCostAmount)}
        </DataDisplay>
      </Grid>
    </Grid>
  );
};
